// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2mW7i","list":"styles_list__2er6A"};